import React, { useContext, useState, useEffect, useMemo, useRef } from "react";
import { Row, Col } from "react-bootstrap";
import Accordion from "../../../components/Accordion";

import FeeAndAdjustmentResearchForm from "./FeeAndAdjustmentResearchForm";

import FeeAndAdjustmentDirectExport from "./FeeAndAdjustmentDirectExport";
import { UserContext } from "shared/context/UserContext";
import { IsNullOrEmpty } from "shared/helpers/NullEmptyHelpers";

import ErrorHandler from "../../../components/core/ErrorHandler";

import FeeAndAdjustmentDetailsModal from "./FeeAndAdjustmentDetailsModal";

// import { GridColumnMenuCheckbox } from "../../grid/Kendo/ColumnMenuCheckboxFilter";

import { GridColumn } from "@progress/kendo-react-grid";

import { ApplicationInsights } from "../../../components/AppInsights/TelemetryService";

import SharedMainSelectableClientGrid from "shared/components/grids/clientGrid/SharedMainSelectableClientGrid";

import useGridDataStateResetProcessing from "shared/hooks/useGridDataStateResetProcessing";

import useGridButtons from "shared/components/grids/hooks/useGridButtons";

import {
    MoneyCell,
    AggregateMoneyFooterCell,
} from "../../../components/grid/Kendo/CustomKendoGridCells";
import { ZIndexContext } from "@progress/kendo-react-common";

import {
    DefaultColumnWidth,
    DefaultBooleanOrShortWidthColumnWidth,
} from "../../../components/grid/Kendo/KendoGridAndColumnConstants";

export default function FeeAndAdjustmentResearch(props) {
    const [submittedFormData, setSubmittedFormData] = useState(null);
    const [error, setError] = useState({});

    const [mainGridAggregates, setMainGridAggregates] = useState([]);

    const [showDetails, setShowDetails] = useState(false);

    const [selectedFeeCodes, setSelectedFeeCodes] = useState(false);

    const [directExportIsProcessing, setDirectExportIsProcessing] =
        useState(false);
    const [directExportType, setDirectExportType] = useState(false);

    //The direct export logic is now in the FeeAndAdjustmentDirectExport component, this state will be set by the direct export component and will notify this component if the data is still loading
    //This will be used to show a message to the user that the export is processing
    const [isDirectExportDataLoading, setIsDirectExportDataLoading] =
        useState(false);

    const [isDirectExportDataError, setIsDirectExportDataError] = useState(false);
    const [isDirectExportDataMessage, setIsDirectExportDataMessage] = useState(false);

    const userContext = useContext(UserContext);

    const userEmail = userContext.email;

    const { AddGridButton, gridButtons } = useGridButtons();
    const clientGridRef = useRef();

    const sendAggregatesToParent = (aggregatesFromSharedGrid) => {
        setMainGridAggregates(aggregatesFromSharedGrid.data);
    };

    const {
        gridDataStateResetProcessingInitiated,
        InitiateGridDataStateReset,
        GridDataStateResetCompleted: onGridDataStateResetCompleted,
    } = useGridDataStateResetProcessing();

    const generateReportForSelectables = (clickedItem) => {
        const selectedDataKeys = clientGridRef.current
            ? clientGridRef.current.GetSelectedGridDataKeys()
            : null;

        //convert the array to a comma separated list
        var selectedFeeCodesCommaseparated = selectedDataKeys.join(",");
        setSelectedFeeCodes(selectedFeeCodesCommaseparated);

        setDirectExportIsProcessing(true);
        setDirectExportType(clickedItem.toLowerCase());
    };

    //set the grid buttons
    useEffect(() => {
        AddGridButton(
            "Get Reports For Selected Codes",
            sendSelectablesToParent,
            true
        );

        AddGridButton(
            "Export Details For Selected Reports",
            generateReportForSelectables,
            true,
            "Excel,CSV"
        );
    }, []);

    useEffect(() => {
        if (isDirectExportDataError) {
            // isDirectExportDataMessage is only set once the server-side export fallback has
            // resolved (success or failure) — never the raw GetDetails error body, which for an
            // infra-level timeout is a generic IIS "resource has been moved" page.
            const description =
                isDirectExportDataMessage && isDirectExportDataMessage.description;

            if (!IsNullOrEmpty(description)) {
                alert(description);
            }
        }
        setIsDirectExportDataError(false);
    }, [isDirectExportDataError]);

    const gridApiParams = useMemo(() => {
        if (IsNullOrEmpty(userEmail)) {
            return {};
        }

        if (!submittedFormData) {
            return {};
        }

        let params = {
            user: userEmail,
            fromDate: submittedFormData.fromDate,
            toDate: submittedFormData.toDate,
            locations: submittedFormData.locations,
            payers: submittedFormData.payers,
            adjustmentType: submittedFormData.adjustmentType,
            checkNumber: submittedFormData.checkNumber,
            feeCode: submittedFormData.feeCode,
            remittanceStatus: submittedFormData.remitStatus,
        };

        return params;
    }, [submittedFormData]);

    function handleFormSubmit(e) {
        InitiateGridDataStateReset();
        setSubmittedFormData(e);
    }

    const MainGridAggregateMoneyFooterCell = (props) => {
        var options = {
            aggregateData: mainGridAggregates,
            removeNegativeSymbol: true,
        };

        return AggregateMoneyFooterCell(props, options);
    };

    const CustomMoneyCell = (props) => {
        var options = {
            removeNegativeSymbol: true,
        };

        return MoneyCell(props, options);
    };

    let CustomViewReportCell = (props) => {
        return (
            <td
                {...props.tdProps}
                colSpan={1}
                style={{
                    color: "#015CAB",
                }}
            >
                <a
                    style={{
                        cursor: "pointer",
                    }}
                    onClick={() => {
                        setShowDetails(true);
                        setSelectedFeeCodes(props.dataItem["feeCode"]);
                    }}
                >
                    View Report
                </a>
            </td>
        );
    };

    const sendSelectablesToParent = () => {
        const selectedDataKeys = clientGridRef.current
            ? clientGridRef.current.GetSelectedGridDataKeys()
            : null;

        var selectedFeeCodesCommaseparated = selectedDataKeys.join(",");

        setShowDetails(true);
        setSelectedFeeCodes(selectedFeeCodesCommaseparated);
    };

    let isExportProcessing =
        directExportIsProcessing && isDirectExportDataLoading;

    let featureClass = "feature" + (isExportProcessing ? " disabled" : "");

    return (
        <div className={featureClass}>
            {/* <LoadingSpinner
        isDataLoading={isLoading}
        controlsName={"FeeAndAdjustmentResearch"}
      /> */}

            <ErrorHandler
                error={error}
                onClose={() => {
                    setError({});
                }}
            />

            <Accordion defaultExpanded label="Search & Filter">
                <Row>
                    <Col className="higher-zindex-filters">
                        <FeeAndAdjustmentResearchForm handleFormSubmit={handleFormSubmit} />
                    </Col>
                </Row>
            </Accordion>

            {isExportProcessing && (
                <Row>
                    <Col md={10} style={{ textAlign: "right" }}>
                        <div
                            style={{
                                fontSize: "small",
                                color: "red",
                                fontWeight: "bold",
                                fontStyle: "italic",
                                padding: "10px",
                            }}
                        >
                            Export Details is processing
                        </div>
                    </Col>
                </Row>
            )}

            <Row>
                <Col md={10} className="tight-grid">
                    <SharedMainSelectableClientGrid
                        ref={clientGridRef}
                        isSelectable={true}
                        apiGetEndpoint={"api/FeeAndAdjustment/GetResearch"}
                        apiParameters={gridApiParams}
                        dataItemKey={"feeCode"}
                        aggregateColumnSettings={[{ aggregate: "sum", field: "total" }]}
                        sendAggregatesParentCallback={sendAggregatesToParent}
                        exportFileNamePrefix={"Fee&Adjustment"}
                        gridButtons={gridButtons}
                        gridDataStateResetProcessingInitiated={
                            gridDataStateResetProcessingInitiated
                        }
                        onGridDataStateResetCompleted={onGridDataStateResetCompleted}
                    >
                        <GridColumn
                            key={""}
                            field={""}
                            title={"View Report"}
                            width={DefaultBooleanOrShortWidthColumnWidth()}
                            filterable={false}
                            sortable={false}
                            cells={{
                                data: CustomViewReportCell,
                            }}
                        />
                        <GridColumn
                            key={"feeCode"}
                            field={"feeCode"}
                            title={"Fee Code"}
                            width={DefaultColumnWidth()}
                        />
                        <GridColumn
                            key={"description"}
                            field={"description"}
                            title={"Description"}
                        />
                        <GridColumn
                            key={"total"}
                            field={"total"}
                            title={"Total"}
                            width={DefaultColumnWidth()}
                            filter={"numeric"}
                            cells={{
                                data: CustomMoneyCell,
                                footerCell: MainGridAggregateMoneyFooterCell,
                            }}
                            footerCell={MainGridAggregateMoneyFooterCell}
                        />
                    </SharedMainSelectableClientGrid>
                </Col>
            </Row>

            <FeeAndAdjustmentDirectExport
                email={userEmail}
                submittedFormData={submittedFormData}
                selectedFeeCodes={selectedFeeCodes}
                directExportIsProcessing={directExportIsProcessing}
                setDirectExportIsProcessing={setDirectExportIsProcessing}
                directExportType={directExportType}
                setIsDirectExportDataLoading={setIsDirectExportDataLoading}
                setIsDirectExportDataError={setIsDirectExportDataError}
                setIsDirectExportDataMessage={setIsDirectExportDataMessage}
            ></FeeAndAdjustmentDirectExport>

            <ZIndexContext.Provider value={10003}>
                <FeeAndAdjustmentDetailsModal
                    submittedFormData={submittedFormData}
                    selectedFeeCodes={selectedFeeCodes}
                    auth={props}
                    show={showDetails}
                    onClose={() => {
                        setShowDetails(false);
                    }}
                />
            </ZIndexContext.Provider>
        </div>
    );
}
